import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AlertService, LoaderEnabled, ResourceService, UserService } from 'sce-core';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { DockDoorBookingKeyEventHandlerService } from '../../../../features/outbound/dock-door-booking/dock-door-booking-home/services/dock-door-booking-key-event-handler.service';
import { SearchParams } from '../../../search/models/search-params.model';
import { SearchStatus } from '../../../search/models/search-status.model';
import { SearchService } from '../../../search/search.service';
import { SharedServiceRegistry } from '../../../shared-service-registry';

@Component({
  selector: 'lfwms-door-blocking-popup',
  templateUrl: './door-blocking-popup.component.html',
  styleUrls: ['./door-blocking-popup.component.css']
})
export class DoorBlockingPopupComponent implements OnInit {

  private searchService: SearchService;
  private resourceService: ResourceService;
  private keyEventHandler: DockDoorBookingKeyEventHandlerService;
  private userService: UserService;
  private tableId: string = 'doorblocktd';
  private moduleId: string = 'DOORBLOCK';
  public cellDataMap: any;
  public metadataMap: any;
  public filteredMetaData: any;
  private dateFormat: string = 'DD/MM/YYYY';
  private displayMode = 'C';
  private http$: HttpClient;
  private propertyNametoDataMap = {
    blockSlotKey: 'blockingId',
    facility: 'facility',
    fromDate: 'date',
    toDate: 'date',
    fromTime: 'bookingTimefr',
    toTime: 'bookingTimeto',
    fromDoor: 'fromDoor',
    reason: 'reason'
  };
  private eventSubject = new Subject<any>();

  constructor(
    private coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry,
    private alertService: AlertService) {
    this.http$ = coreServiceRegistry.http$;
    this.resourceService = coreServiceRegistry.resourceService;
    this.userService = coreServiceRegistry.userService;
  }

  ngOnInit() {
  }

  public initializeComponents(keyEventHandler: DockDoorBookingKeyEventHandlerService, data: any) {
    this.keyEventHandler = keyEventHandler;
    this.searchService = this.createSearchService();
    this.searchService.clearSavedSearchConfig(); // Clear any old data
    // this.searchService.setSearchCriteria(this.createSearchCriteria(primaryKeyName, primaryKeyValue));
    this.searchService.fetchMetadataOnly().subscribe((metaData: any) => {
      // this.searchService.performSearch();
      this.metadataMap = {};
      metaData.columnList.forEach((column: any) => {
        this.metadataMap[column.propertyName] = column;
      });
      this.setFilteredMetaData(data.facility);
      if (!data.blockingId) {
        this.displayMode = 'C';
        this.searchService.createUniqueId(this.moduleId).subscribe(res => {
          if (res && res.documentNumber) {
            data.blockingId = res.documentNumber;
            this.cellDataMap = this.createNewDocumentDataMap(metaData, data);
          } else {
            this.alertService.clearAll().error('Failed to generate Unique ID for ' + this.moduleId);
          }
        }, (err) => this.alertService.clearAll().error(err));
      } else {
        this.displayMode = 'E';
        this.cellDataMap = this.createNewDocumentDataMap(metaData, data);
      }
    });
  }

  setFilteredMetaData(facility: string) {
    this.filteredMetaData = JSON.parse(JSON.stringify(this.metadataMap));
    if (this.filteredMetaData['fromDoor']) {
      this.filteredMetaData['fromDoor'].values =
        this.getValuesBasedOnFacility(facility, this.metadataMap['fromDoor'].values);
    }
  }

  public getValuesBasedOnFacility(facility: string, originalCoptions: any) {
    let filteredCoptions;
    if (facility) {
      filteredCoptions = originalCoptions.filter(element => element.facility &&
        element.facility.trim().toUpperCase() === facility.trim().toUpperCase());
      if (filteredCoptions.length > 0) {
        filteredCoptions.unshift({ key: '', value: '- Select -', facility: null, userDefineValues: null });
      }
    }
    if (!filteredCoptions || filteredCoptions.length === 0) {
      filteredCoptions = originalCoptions.filter(element => !element.facility);
    }
    if (filteredCoptions.length === 1 && filteredCoptions[0].key === '' &&
      filteredCoptions[0].value.toLowerCase() === '- select -') {
      filteredCoptions = [];
    }
    return filteredCoptions;
  }

  createNewDocumentDataMap(metaData: any, data: any): any {
    const cellDataMap: any = {};
    metaData.columnList.forEach((column) => {
      const property: string = column.propertyName;
      let cVal = null;
      if (data && data[this.propertyNametoDataMap[property]]) {
        cVal = data[this.propertyNametoDataMap[property]];
      } else if (property === 'facility') {
        const userFacilities: any = this.userService.getUserRestrictions('Facility');
        if (userFacilities === null || userFacilities.length === 0) {
          cVal = column.defaultVal;
        } else {
          cVal = userFacilities[0];
        }
      } else if (property === 'day') {
        cVal = 0;
      } else if (column.type === 'DROPDOWN' || column.type === 'EDITABLEDROPDOWN') {
        cVal = column.defaultVal;
      } else {
        if (column.defaultVal) {
          cVal = column.defaultVal;
        } else if (column.dataType === 'String') {
          cVal = '';
        }
      }
      cellDataMap[property] = {
        cName: property,
        cVal
      }
      if (this.displayMode === 'E') {
        cellDataMap[property]['cValOrig'] = cVal;
      }
    });
    return cellDataMap;
  }

  private createSearchService(): SearchService {
    const searchParams = new SearchParams();
    searchParams.tableId = this.tableId;
    searchParams.isFullFetch = true;
    searchParams.alertService = this.alertService;
    const searchStatus = new SearchStatus();
    const searchService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
    return searchService;
  }

  // method used to translate the labels
  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  valueChanged(key, event) {
    let preVal: any, newVal: any;
    if (event.type) {
      preVal = event.preVal;
      newVal = event.newVal;
    } else {
      preVal = this.cellDataMap[key].cVal;
      newVal = event;
    }
    this.cellDataMap[key].cValPrev = preVal;
    this.cellDataMap[key].cVal = newVal;
    ;
  }

  block() {
    this.cellDataMap['toDate'] = { ...this.cellDataMap['fromDate'] };
    this.cellDataMap['toDate'].cName = 'toDate';
    const typeName = 'original_';
    let entityProperties = [];
    let privilege = 'dock_door_access';
    Object.values(this.cellDataMap).forEach((cell: any) => {
      if (cell.cValOrig) {
        let cValOrig = cell.cValOrig;
        if ((cell.cName === 'fromTime' || cell.cName === 'toTime')) {
          cValOrig = new Date(this.cellDataMap['fromDate'].cValOrig);
          const time = cell.cValOrig.split(':');
          cValOrig.setHours(+time[0], +time[1], 0, 0);
          cValOrig = this.fixTimeZoneOffset(cValOrig);
        } else if (cell.cName === 'fromDate' || cell.cName === 'toDate') {
          cValOrig = this.fixTimeZoneOffset(cValOrig);
        }
        entityProperties.push({ cName: typeName + cell.cName, cVal: cValOrig });
      }
      let cVal = cell.cVal;
      if ((cell.cName === 'fromTime' || cell.cName === 'toTime') && cVal) {
        cVal = new Date(this.cellDataMap['fromDate'].cVal);
        const time = cell.cVal.split(':');
        cVal.setHours(+time[0], +time[1], 0, 0);
        cVal = this.fixTimeZoneOffset(cVal);
      } else if ((cell.cName === 'fromDate' || cell.cName === 'toDate') && cVal) {
        cVal = this.fixTimeZoneOffset(cVal);
      }
      entityProperties.push({ cName: cell.cName, cVal });
    });
    if (this.displayMode === 'C') {
      entityProperties.push({ cName: 'isNewItem', cVal: true });
    }
    this.saveEntity(entityProperties, privilege).subscribe(response => {
      if (response.statusCode && response.statusCode === 200) {
        const successMsg = 'msg_save_succ';
        this.alertService.clearAll().success(this.resourceService.get(successMsg));
        this.notifyEvent({ type: 'refresh' });
        this.cancel();
      } else {
        this.alertService.clearAll().error(this.resourceService.get(response.statusMessage));
      }
    }, err => {
      this.alertService.clearAll().error(this.resourceService.translateServerResponse(err));
    });
  }

  cancel() {
    this.sharedServiceRegistry.sceModalService.modalReference.hide();
  }

  // service call to save an entity detail while creating
  // LFWM-3191- made a new api /withPriv (replacement for setup api)
  //  to pass the privileges for checking the privileges at the backend level.
  @LoaderEnabled()
  public saveEntity(entityProperties: any, privilege: any): Observable<any> {
    let request = [{
      'moduleProperties': entityProperties,
      'screenType': this.tableId,
      'privilege': privilege
    }];
    let response$;
    if (this.displayMode === 'C') {
      response$ = this.http$.post(`api/setup/withPriv/`, JSON.stringify(request));
    } else {
      response$ = this.http$.put(`api/setup/withPriv/`, JSON.stringify(request));
    }
    // LFWM-3191-handling 403-forbidden error.
    return response$.catch((error: any) => {
      if (error.error.status === 403) {
        return Observable.throw(error.error.message);
      } else if (error.error.length !== 0) {
        if (error.error.statusCode && error.error.statusCode !== 200) {
          return Observable.throw(error.error.statusMessage);
        } else if (error.status === 400) {
          return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
        }
      }
    });
  }

  public notifyEvent(value: any) {
    this.eventSubject.next(value);
  }

  public receiveEvent(): Observable<any> {
    return this.eventSubject.asObservable();
  }

  fixTimeZoneOffset(date: Date) {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/dock-door-booking-popups/door-blocking-popup/door-blocking-popup.component.ts